import React from 'react'

function CouponBand({text}) {
  return (
    <div className='bs-coupon-band'>
        <p className='bs-coupon-band__text' dangerouslySetInnerHTML={{__html: text}}></p>
    </div>
  )
}

export default CouponBand